import ReduxRestEntity from '../../../../utils/reduxRestEntity';
import GrantsAPI from '../../../../utils/api/grantsAPI';

const entity = new ReduxRestEntity({
  name: 'grants',
  primaryKey: 'key',
  api: GrantsAPI(),
});

export default entity;
